/* eslint-disable */

import store from '../store';
import _intersection from "lodash/intersection";
import moment from 'moment'
import i18next from "i18next";
import { HTTP_HYPER_ESPACE_BACKEND, HTTP_AUTH } from '@/services/http-common'

const axios = require("axios");
const jwtDecode = require('jwt-decode');

function storeAuthenticatedUser(user) {
    store.commit('setUser', user);
}

function removeAuthenticatedUser() {
    store.commit('setUser', null);
}

function storeAuthenticatedSitimmoUser(sitimmoUser) {
    store.commit('setSitimmoUser', sitimmoUser);
}

function removeAuthenticatedSitimmoUser() {
    store.commit('setSitimmoUser', null);
}

function storeUserToken(token) {
    store.commit('setToken', token);
}

export function getUserToken() {
    return store.getters['getToken'];
}

function removeUserToken() {
    store.commit('setToken', null);
}
function removePopupProduitSfc() {
	store.commit('setPopupSfcVue', false);
}
function removePopupProduitBienVendus() {
	store.commit('setPopupBienVendusVue', false);
}
function setSocialNetworkIds() {
	store.commit('setSocialNetworkIds', []);
}
function setSocialNetworkCodenames() {
	store.commit('setSocialNetworkCodenames', []);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                removeUserToken();
                removeAuthenticatedUser();
                removeAuthenticatedSitimmoUser();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}

/**
 * Use this when to need to make an api call with the token
 * @returns {{Authorization: string}|{}}
 */
export function authHeader(accept = "application/json") {

    let token = getUserToken();
    if (token) {
        return {Authorization: "Bearer " + token, "Content-Type": "application/json", "Accept": accept};
    } else {
        return {};
    }
}

/**
 * Use this when to need to make an api call with the token
 * @returns {{Authorization: string}|{}}
 */
export function authHeaderXauth() {

    let token = getUserToken();
    if (token) {
        return {"X-AUTH-TOKEN": "Bearer " + token};
    } else {
        return {};
    }
}

// /**
//  * Tente de connecter l'utilisateur avec identifiant et mot de passe.
//  *
//  * @param {string} username
//  * @param {string} password
//  * @returns {boolean}
//  */
// export async function tryAuthenticateWithUsernameAndPassword(username, password) {
//
//     let params = {
//         username: username,
//         password: password
//     };
//
//     return HTTP_AUTH.post('/api/login_check', params)
//         .then(async response => {
//             removeUserToken();
//             if (response.data.token) {
//                 storeUserToken(response.data.token);
//             }
//
//             return await tryRetrieveUser(username);
//         })
//         .catch(error => {
//             return Promise.reject({
//                 code: "auth/error",
//                 message: "Votre login ou votre mot de passe ne sont pas reconnus pour accéder à votre Espace Client."
//             });
//         });
// }

/**
 * Tente de connecter l'utilisateur avec email et mot de passe.
 *
 * @param username
 * @param {string} password
 * @returns {boolean}
 */
export async function tryAuthenticateWithUsernameOrEmailAndPassword(username, password) {
    let params = { username: username, password: password }
    return HTTP_HYPER_ESPACE_BACKEND.post('/connect', params).then(async response => {
        removeUserToken()
        if (response.data.token) {
            storeUserToken(response.data.token)
            const user = JSON.parse(response.data.user)
            if (user && user.active) {
                if (response.data.status && (response.data.status == 'SUSPENDU')) {
                    signOut()
                    return response.data
                }
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                storeAuthenticatedUser(user)
                store.dispatch('resetFilters')
                await loadData()
                return user
			}
        }
        signOut()
        return Promise.reject({
            code: "auth/error",
            message: "Vous n'avez pas de compte Espace Client, ou votre accès à ce dernier est désactivé."
        })
    }).catch(error => {
        return Promise.reject({
            code: "auth/error",
            message: "Votre login ou votre mot de passe ne sont pas reconnus pour accéder à votre Espace Client."
        })
    })
}

export async function loadData() {
    store.commit('setSocialNetworkIds', [])
    store.commit('setSocialNetworkCodenames', [])
    return await Promise.all([loadAdvertiser()])
}

export async function tryAuthenticateWithToken(token) {
    signOut();
    storeUserToken(token);
    let user = await tryRetrieveUser(jwtDecode(token).username);
    store.dispatch('resetFilters');

    return user;
}

/**
 * Tente de connecter l'utilisateur selon sa session en cours.
 *
 * @returns {boolean}
 */
export async function tryAuthenticateWithBrowserData() {
    //TODO you should check if the token is still valid, and maybe call your API to refresh it if needed?
    const token = getUserToken();
    return !!token;
}

/**
 * Vérifie si une session valide est ouverte.
 *
 * @returns {boolean}
 */
export async function isAuthenticated() {
    return new Promise(resolve => {
        window.setTimeout(async function () {
            const token = getUserToken();
            if (token && Date.now() > jwtDecode(token).exp * 1000) {
                await refreshToken();
            }

            return resolve(!!token);
        }, Math.random() * 250);
    });
}

export async function refreshToken() {
    // bug https://redmine.ubiflow.net/issues/94943
    // On arrête de rafraichir les clients gratuitement !
    signOut()
    return
}

/**
 * Retourne l'utilisateur connecté coté back hyper espace.
 *
 * @returns {object}
 */
export function tryRetrieveUser(username, token = null) {
	let params = {
		params: {
			username: username
		}
	};

    // Gestion si on force le token
    if(token) {
        params["headers"] = {
            Authorization: "Bearer " + token,
        }
    }

    return HTTP_HYPER_ESPACE_BACKEND
        .get("/users", params)
        .then(async user => {

            if (user && user.data[0].active) {
                storeAuthenticatedUser(user.data[0]);
                await loadData();

                return user.data[0];
            }

            signOut();
            return Promise.reject({
                code: "auth/error",
                message: "Vous n'avez pas de compte Espace Client, ou votre accès à ce dernier est désactivé."
            });
        })
        .catch(error => {
            signOut();
            return Promise.reject({
                code: "auth/error",
                message: "Vous n'avez pas de compte Espace Client, ou votre accès à ce dernier est désactivé."
            });
        });
}

/**
 * Retourne l'utilisateur depuis passe partout a partir d'un username
 *
 * @returns {object}
 */
export async function getAuthUser(username, token = null) {
    let params = {
        params: {
          username: username
        }
    };
    // Gestion si on force le token
    if(token) {
        params["headers"] = {
            Authorization: "Bearer " + token,
        }
    }

    return HTTP_AUTH
        .get('/users', params)
        .then(response => {
            return response.data["hydra:member"][0];
        })
        .catch(error => {
            return error;
        });

}

/**
 * Lancer une requete de réiniatialisation de mdp
 *
 * @returns {object}
 */
export async function resetPassword(forgot) {

    return HTTP_HYPER_ESPACE_BACKEND
        .post('/reset_password/' + forgot)
        .then(response => {
            return response
        })
        .catch(error => {
            return error;
        });
}

/**
 * Update le mot de passe d'un utilisateur passe partout à partir d'un token (fait d'abord un appel pour récuperer l'id utilisateur a partir de l'ag inclut dans le token)
 */
export async function updateUserPasswordFromToken(token, password) {
    let username = jwtDecode(token).username;
    let authUser = await getAuthUser(username, token);


    if (authUser) {
		authUser.password = password;
        await updateAuthUser(authUser, token)

		let user = await tryRetrieveUser(authUser.username, token);

		if(user.SFCUID){
			if(!user.SFCPasswordReseted){
				user.firstPasswordResetedAt = moment()
			}
			user.SFCPasswordReseted = true;
			await updateUser(user, token)
		}
		if(user.mainAccount){//not for multi user because there is no equivalence inside sitimmo
			await updateSitimmoUser({id: username.replace('ag', ''), mot_de_passe: password}, token);
		}
        return true;
    }

    return false;
}

/**
 * Update un utilisateur coté passe partout
 * @returns {object}
 */
export async function updateSitimmoUser(user, token = null) {
    return HTTP_HYPER_ESPACE_BACKEND
        .put("/annonceur/" + user.id, user)
        .then(async response => {
            return response;
        })
        .catch(error => {
            // this.errored = true
            return error;
        });
}


/**
 * Update un utilisateur coté passe partout
 *
 * @returns {object}
 */
export async function updateAuthUser(user, token = null) {
    let params = {
      headers: token ? {Authorization: "Bearer " + token} : authHeader(),
    };

    return HTTP_AUTH
        .put("/users/" + user.id, user, params)
        .then(async response => {
            return response;
        })
        .catch(error => {
            // this.errored = true
            return error;
        });
}

/**
 * Update un utilisateur coté hyper espace api
 *
 * @returns {object}
 */
export async function updateUser(user, token = null) {
    return HTTP_HYPER_ESPACE_BACKEND
        .put("/users/" + user.id, user)
        .then(async response => {
            return response;
        })
        .catch(error => {
            // this.errored = true
            return error;
        });
}

/**
 * Chargement des données, produits, diffusions, ... de l'annonceur
 * @returns {object}
 */
export async function loadAdvertiser(token = null) {
    const lang = i18next.language
    const url = "/load-advertiser?lang=" + lang
    return HTTP_HYPER_ESPACE_BACKEND
        .get(url)
        .then(response => {
            let sitimmoUser = store.getters.getSitimmoUser
            let user = store.getters.getUser

            sitimmoUser = response.data.advertiser
            sitimmoUser.linkedinUrlConnexion = response.data.linkedinUrlConnexion
            sitimmoUser.immowebUrlConnexion = response.data.immowebUrlConnexion
            sitimmoUser.selogerUrlConnexion = response.data.selogerUrlConnexion
            user.diffusions = response.data.diffusions
            if (!user.socialNetworkIds) {
                user.socialNetworkIds = []
                user.socialNetworkCodenames = []
            }
            user.socialNetworkIds = user.socialNetworkIds.concat(response.data.socialNetworkIds)
            user.socialNetworkIds = [...new Set(user.socialNetworkIds)]
            user.socialNetworkCodenames = user.socialNetworkCodenames.concat(response.data.socialNetworkCodenames)

            user.possedeInstagram = response.data.possedeInstagram
            user.possedeClap = response.data.possedeClap
            user.isUSH = response.data.isUSH
            user.haveFacebook = response.data.haveFacebook
            user.haveFacebookBV = response.data.haveFacebookBV
            user.haveFacebookEdito = response.data.haveFacebookEdito
            user.haveGMB = response.data.haveGMB
            user.haveGMBBV = response.data.haveGMBBV
            user.haveGMBEdito = response.data.haveGMBEdito
            user.haveInstagramBV = response.data.haveInstagramBV
            user.haveInstagramEdito = response.data.haveInstagramEdito
            user.haveLinkedIn = response.data.haveLinkedIn
            user.haveLinkedInBV = response.data.haveLinkedInBV
            user.haveLinkedInEdito = response.data.haveLinkedInEdito
            user.popupMaintenanceClose = false

            store.commit('setSitimmoUser', sitimmoUser);
            store.commit('setUser', user)
            store.commit('setCountries', response.data.pays)
            store.commit('productLine/setProducts', response.data.product_line);
            if(store.getters.isImmo) {
                store.commit('setOfferTypes', response.data.type_offre);
            }
            return response.data
        })
        .catch(error => {
            return error
        });
}

/**
 * Déconnecte la session courante.
 */
export function signOut() {
    removeUserToken();
    removeAuthenticatedUser();
    removeAuthenticatedSitimmoUser();
	removePopupProduitSfc();
}

/**
 * Vérifie les permissions de l'utilisateur
 *
 * @param {object} user
 * @param {string[]} permissions
 * @returns {boolean}
 */
export async function hasPermissions(user, permissions) {
    //TODO implement your own permission system and unit test ;)
    return new Promise(resolve => {
        window.setTimeout(function () {
            return resolve(
                !!_intersection(user.roles || [], permissions || []).length
            );
        }, Math.random() * 250);
    });
}

/**
 * Get a token for another user (switch)
 */
export function getSwitchedToken(usernameToSwitch) {
    return HTTP_HYPER_ESPACE_BACKEND.get("/switch_user/" + usernameToSwitch)
        .then(response => {
            return response.data.token;
        })
        .catch(error => {
            return error;
        });
}






